/**
 * AppSync AWSJSON decoding helpers.
 *
 * AWSJSON fields (AdminTask resultRef / detail / input / correlation, …) arrive
 * SINGLE- or DOUBLE-encoded: an object, a JSON string, or a JSON string whose
 * decoded content is itself a JSON string. A single JSON.parse on a
 * double-encoded value yields a string — not an object — which silently broke
 * legacy guide-image commit (empty candidate → no imageUrl/assetId).
 *
 * Mirror of admin-remix `app/ai-visibility/lib/awsJson.ts`.
 */
/** Parse repeatedly until we reach a non-string value (or give up after 4 hops). */
export const deepParseAwsJson = (raw) => {
    let val = raw;
    for (let i = 0; i < 4 && typeof val === 'string'; i += 1) {
        if (!val)
            return null;
        try {
            val = JSON.parse(val);
        }
        catch {
            return null;
        }
    }
    return val;
};
/** Deep-parse an AWSJSON value and narrow to a plain object, or null. */
export const parseAwsJsonObject = (raw) => {
    const val = deepParseAwsJson(raw);
    return val && typeof val === 'object' && !Array.isArray(val)
        ? val
        : null;
};
//# sourceMappingURL=parseAwsJson.js.map